import { SignalServiceBase } from "cayo.ui";

export type PropertiesPanelSignals = "refresh" | "close" | "loading";

export class PropertiesPanelSignalService extends SignalServiceBase<PropertiesPanelSignals, any> {}

export type IPropertiesPanelSignals = InstanceType<typeof PropertiesPanelSignalService>;
